import { Modal } from "src/atoms/Modal";
import { StyledCloseButton } from "src/organisms/ProductView/ProductView.styled";
import {
  PhotoModalCloseWrapper,
  PhotoModalContainer,
} from "./ProductPhotos.styled";
import { ImageCarousel } from "./ImageCarousel";
import { useCallback } from "react";

type ProductPhotoModalProps = {
  isZoomOpen: boolean;
  photos: string[];
  productName: string;
  setIsZoomOpen: (isOpen: boolean) => void;
  onClose?: () => void;
};

function ProductPhotoModal({
  isZoomOpen,
  photos,
  productName,
  setIsZoomOpen,
}: ProductPhotoModalProps): JSX.Element {
  const handleClose = useCallback(() => {
    setIsZoomOpen(false);
  }, [setIsZoomOpen]);

  return (
    <Modal
      isOpen={isZoomOpen}
      withHeader={false}
      onClose={handleClose}
      fullWidth
      fullHeight
      centerOnScreen
    >
      <PhotoModalContainer>
        <PhotoModalCloseWrapper>
          <StyledCloseButton
            sx={{ opacity: 0.5 }}
            fill="tone.anthraciteDark"
            onClick={() => {
              setIsZoomOpen(false);
            }}
          />
        </PhotoModalCloseWrapper>
        <ImageCarousel
          photos={photos}
          identifier="zoom"
          productName={productName}
        />
      </PhotoModalContainer>
    </Modal>
  );
}

export { ProductPhotoModal };
